// DATA BREACH RESPONSE PLAN — Reservo
// Required under: Privacy Act 1988 (Cth), Notifiable Data Breaches scheme

export const DATA_BREACH_RESPONSE_PLAN = {
  id: 'data-breach-response-plan',
  title: 'Data Breach Response Plan',
  version: 'v1.0-2026-05-17',
  effectiveDate: '17/05/2026',
  audience: 'internal',
  content: `DATA BREACH RESPONSE PLAN — RESERVO

Status: DRAFT — pending solicitor review

1. PURPOSE

This plan sets out Reservo's response to suspected or actual data breaches under the Privacy Act 1988 (Cth) and the Notifiable Data Breaches (NDB) scheme.

2. DEFINITIONS

2.1 "Data breach" — unauthorised access to, unauthorised disclosure of, or loss of, personal information held by Reservo.

2.2 "Eligible data breach" — a data breach that is likely to result in serious harm to an individual whose personal information is involved.

2.3 "Serious harm" — physical, psychological, emotional, financial, or reputational harm of a kind a reasonable person would consider serious.

3. INCIDENT RESPONSE TEAM

3.1 Primary responder: David Williams (Operator) — admin@reservo.au — 0435 679 630.

3.2 Secondary responder: nominated technical contact (to be appointed before launch).

3.3 External advisers may be engaged: solicitor, cyber-insurance broker, forensic IT specialist.

4. RESPONSE STAGES

4.1 STAGE 1 — Contain (within 1 hour of detection)
  (a) Identify the nature and extent of the breach.
  (b) Stop further unauthorised access — isolate affected systems, revoke compromised credentials, disable affected accounts.
  (c) Preserve evidence — capture logs, screenshots, system state.
  (d) Open an incident log in the Reservo incident register.

4.2 STAGE 2 — Assess (within 24 hours of detection)
  (a) Determine which individuals are affected.
  (b) Determine what personal information is involved (categories, sensitivity, volume).
  (c) Assess likelihood and severity of serious harm.
  (d) Determine whether the breach is an "eligible data breach" under the NDB scheme.

4.3 STAGE 3 — Notify (within 30 days of detection, sooner if eligible)
  (a) If eligible data breach: notify the Office of the Australian Information Commissioner (OAIC) using the official Notifiable Data Breach form.
  (b) If eligible data breach: notify each affected individual where practicable, using their preferred contact method.
  (c) Notification content: nature of breach, type of information involved, recommended steps for affected individuals, Reservo's response, contact for further information.
  (d) If notification of individuals is not practicable, publish a statement on the Reservo website.

4.4 STAGE 4 — Review (within 60 days of resolution)
  (a) Conduct post-incident review.
  (b) Identify root cause and remediation actions.
  (c) Update controls, systems, training, or this plan as required.
  (d) Document outcomes in the Reservo audit log.

5. ASSESSMENT FACTORS

5.1 Whether the breach is "eligible" depends on:
  (a) the kind of information disclosed (e.g. credit card data, health information, identity documents create higher risk);
  (b) sensitivity of the information;
  (c) any security measures protecting the information (encryption, hashing);
  (d) the likelihood the information will be accessed or used by an unauthorised person;
  (e) the kind of harm that may result.

6. INDIVIDUAL NOTIFICATIONS

6.1 Notifications to affected individuals must:
  (a) describe the breach;
  (b) describe the kind of information involved;
  (c) recommend protective steps the individual should take;
  (d) provide contact information for queries.

6.2 Reservo will use the same contact channel the individual uses for the service (email, SMS, or in-app notification).

7. REGULATORY NOTIFICATION

7.1 OAIC notification is submitted via the Notifiable Data Breach form at oaic.gov.au.

7.2 Reservo also notifies (where relevant):
  (a) NSW Police if the breach involves criminal activity;
  (b) the Australian Cyber Security Centre for significant cyber incidents;
  (c) financial institutions or Stripe if payment data is involved;
  (d) the NSW Point to Point Transport Commissioner if the breach involves trip safety records.

8. RECORD KEEPING

8.1 All breaches — eligible or not — are recorded in the Reservo data breach register for a minimum of 7 years.

8.2 The register captures: date detected, date contained, root cause, individuals affected, information involved, notification dates, regulatory notifications, remediation actions, post-incident review outcomes.

9. TESTING

9.1 The Operator simulates a data breach response at least annually using a tabletop exercise.

9.2 Findings drive plan updates.

10. CONTACT FOR PRIVACY MATTERS

David Williams, Privacy Officer
Email: admin@reservo.au
Phone: 0435 679 630

---
VERSION HISTORY
v1.0 — 17/05/2026 — Initial draft for solicitor review.

---
THIS DOCUMENT IS A DRAFT FOR PRE-LAUNCH REVIEW.`,
};